import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { GuaranteeFundSC } from './guarantee-fund.styled';
import InfoBanner from '../../components/info-banner';
import ContentWrap from '../../components/content-wrap';
import GuaranteeFundBanner from '../../components/guarantee-fund-banner';
import { getInvestorDashboardData as getInvestorDashboardDataAction } from '../../redux/action';

function GuaranteeFund({ guaranteeFund, getInvestorDashboardData }) {
  useEffect(() => {
    getInvestorDashboardData();
  }, [getInvestorDashboardData]);

  return (
    <GuaranteeFundSC>
      <InfoBanner>
        <GuaranteeFundBanner
          total={Number(guaranteeFund?.total)}
          free={Number(guaranteeFund?.free)}
          used={Number(guaranteeFund?.used)}
        />
      </InfoBanner>
      <ContentWrap />
    </GuaranteeFundSC>
  );
}

const mapStateToProps = (state) => ({
  guaranteeFund: state.dashboard.guaranteeFund,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInvestorDashboardData: getInvestorDashboardDataAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(GuaranteeFund);
